/* global axios */
import ApiClient from '../ApiClient';

class ProductCatalogApi extends ApiClient {
  constructor() {
    super('integrations/product_catalog', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  send({ conversationId, catalog, collection, products }) {
    return axios.post(`${this.url}/send_products`, {
      conversation_id: conversationId,
      catalog,
      collection,
      products,
    });
  }
}

export default new ProductCatalogApi();
